import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useStationCategoriesVisibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteServicePointCategorySelect,
    stationsFilter: !!permissions.servicePointFilterCategorySelect
  } as const), [permissions])
};
